module.exports = __webpack_public_path__ + "ef9b5d78100fc9b92861da0ffa027c6b.fbx";